<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
/* ====================== 全局 PC / 移动端自动适配 ====================== */
.pc-version {
  display: block;
}
.mobile-version {
  display: none;
}

@media (max-width: 768px) {
  .pc-version {
    display: none !important;
  }
  .mobile-version {
    display: block !important;
  }
  .mobile-dialog {
    border-radius: 12px !important;
    z-index: 99999 !important;
  }
  .mobile-dialog .el-dialog__body {
    padding: 15px !important;
  }
}

/* 全局弹窗层级 */
/* .el-dialog__wrapper {
  z-index: 9999 !important;
}
.el-dialog {
  z-index: 10000 !important;
} */
/* 新增：给下拉框设置更高层级 */
.el-select-dropdown {
  z-index: 10001 !important; /* 必须大于弹窗的z-index */
}
.el-popper {
  z-index: 10001 !important; /* 兼容其他弹出层组件 */
}
/* 全局折叠样式 */
.search-collapse-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  color: #409eff;
  cursor: pointer;
  user-select: none;
}
.search-collapse-btn:hover {
  color: #66b1ff;
}
.mobile-search-collapse {
  width: 100%;
  text-align: left;
  padding: 8px 0;
  font-size: 14px;
  color: #409eff;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 10px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/App.vue